import { createContext, useContext } from 'react';
import { useSwingHistory } from '../hooks/useSwingHistory';

const SwingHistoryContext = createContext(null);

export function SwingHistoryProvider({ children }) {
  const swingHistory = useSwingHistory();

  return (
    <SwingHistoryContext.Provider value={swingHistory}>
      {children}
    </SwingHistoryContext.Provider>
  );
}

export function useSwingHistoryContext() {
  const context = useContext(SwingHistoryContext);
  if (!context) {
    throw new Error('useSwingHistoryContext must be used within SwingHistoryProvider');
  }
  return context;
}
